// @flow
import * as React from 'react';
import { render } from './utils/render';
import ErrorPage from './error-page';
import Container from './container';

const id = 'root-422';

function NotOnTheWhitelist(): React.Node {
  return (
    <Container>
      <ErrorPage code="216" />
    </Container>
  );
}

render(id, NotOnTheWhitelist);

export default { Page: NotOnTheWhitelist, id };
